import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/pro-regular-svg-icons";

const QuantityInput = ({ min, max, onValueChange, isDisabled, propClass}) => {
	const [count, setCount] = useState(min);

	useEffect(() => {
		onValueChange(count);
	}, [count, onValueChange]);

	const handleIncrement = () => {
		if (count < (max)) {
			setCount(count + 1);
		}
	};

	const handleDecrement = () => {
		if (count > (min)) {
			setCount(count - 1);
		}
	};

	const handleKeyDown = (event) => {
		if (event.keyCode === 13 || event.keyCode === 27) {
			event.preventDefault();
			event.target.blur();
		} else if (event.keyCode === 38) {
			handleIncrement();
		} else if (event.keyCode === 40) {
			handleDecrement();
		}
	};

	const handleFocus = (e) => {
		e.target.setSelectionRange(0, e.target.value.length);
	};

	const handleBlur = (e) => {
		onValueChange(count);
	};

	const handleInputChange = (e) => {
		const newValue = parseInt(e.target.value, 10);
		if (!isNaN(newValue) && newValue >= (min) && newValue <= (max)) {
			setCount(newValue);
		}
	};

	return (
		<div className={`quantity-input${typeof propClass === "string" && propClass.length > 0 ? " " + propClass : ""}`} data-reactroot="">
			<button
				type="button"
				className="quantity-input__button"
				data-quantity-action="decrement"
				onClick={handleDecrement}
				disabled={count === (min)}
			>
				<FontAwesomeIcon icon={faMinus} />
			</button>
			<input
				type="text"
				aria-label="Quantity"
				pattern="\d*"
				value={count}
				onChange={handleInputChange}
				onFocus={handleFocus}
				onKeyDown={handleKeyDown}
				onBlur={handleBlur}
				disabled={isDisabled}
			/>
			<button
				type="button"
				className="quantity-input__button"
				data-quantity-action="increment"
				onClick={handleIncrement}
				disabled={count === (max)}
			>
				<FontAwesomeIcon icon={faPlus} />
			</button>
		</div>
	);
};

export default QuantityInput;
